var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Upgrade auf PRO",
        "ok-text": "Jetzt upgraden",
        "ok-disabled": !_vm.dataValid || _vm.loading,
        "hide-cancel": _vm.loading,
        "hide-close": _vm.loading,
        size: "lg"
      },
      on: {
        ok: _vm.upgrade,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _vm.loadingUpgradeInfos
        ? _c("Loading", { attrs: { text: "Lade Daten..." } })
        : _vm.upgrading
        ? _c("Loading", { attrs: { text: "Upgrade läuft..." } })
        : [
            !_vm.upgradeInfos.canUpgrade
              ? _c("div", [
                  _vm._v(
                    "Du hast bereits das beste Paket, ein Upgrade ist derzeit nicht\n\t\t\tmöglich!\n\t\t"
                  )
                ])
              : [
                  _vm.upgradeInfos.feeComprehensive
                    ? _c("div", [
                        _c("div", [
                          _vm._v("\n\t\t\t\t\tFür "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.upgradeInfos.feeComprehensive) +
                                " Token"
                            )
                          ]),
                          _vm._v(
                            " kannst du das Stellenprofil auf PRO\n\t\t\t\t\tupgraden. Damit werden die Daten für alle Kandidaten in diesem Stellenprofil freigeschalten.\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.upgradeInfos.canAffordComprehensive
                          ? _c(
                              "div",
                              { staticClass: "mt-2" },
                              [
                                _c("JonInfo", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "message",
                                        fn: function() {
                                          return [
                                            _c("div", [
                                              _vm._v(
                                                "Dein Guthaben reicht leider nicht aus."
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "mt-2" }, [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "/kundenbereich/verrechnung"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Klicke hier um Token zu kaufen"
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2096557535
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeOptions
                    ? _c(
                        "FormGroup",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            label: "Wähle das gewünschte Upgrade:",
                            "label-classes": ["font-weight-extra-bold"]
                          }
                        },
                        [
                          _c("RadioGroup", {
                            attrs: { options: _vm.typeOptions },
                            model: {
                              value: _vm.type,
                              callback: function($$v) {
                                _vm.type = $$v
                              },
                              expression: "type"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }